import PropTypes from 'prop-types';
import styled from 'styled-components';
import { RadioMixin } from '../../mixins/components/RadioMixin';
import { FormControl } from '../FormControl/FormControl';

/**
 * A native ["radio" input](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/radio)
 * element. In general, you will want to use this with the `LabeledControl` component.
 *
 * @related ['FieldSet', 'LabeledControl']
 * @since 1.8.0
 */
var Radio = /*#__PURE__*/styled(FormControl).withConfig({
  displayName: "Radio",
  componentId: "c11n-8-111-1__sc-yicu80-0"
})(["", ""], RadioMixin);
Radio.displayName = 'Radio';
Radio.propTypes = {
  /**
   * @deprecated Use the native `id` attributed if you want to manually set the id, otherwise
   * let `LabeledControl` set this for you.
   */
  controlId: PropTypes.string,
  /**
   * Sets the checked state of the input and use as a
   * [controlled component](https://reactjs.org/docs/forms.html#controlled-components).
   */
  checked: PropTypes.bool,
  /**
   * Sets the checked state of the input and use as an
   * [uncontrolled component](https://reactjs.org/docs/uncontrolled-components.html).
   */
  defaultChecked: PropTypes.bool,
  /**
   * Mark the input as disabled. Can also be inherited from a LabeledControl or FieldSet parent.
   */
  disabled: PropTypes.bool,
  /**
   * The native `name` attribute used to link multiple inputs together.
   */
  name: PropTypes.string,
  /**
   * Marks the input as required with the native [`required`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/required)
   * attribute.
   * Can be controlled by `FormField` context.
   */
  required: PropTypes.bool,
  /**
   * The HTML input type.
   * @ignore
   */
  type: PropTypes.string
};
Radio.defaultProps = {
  type: 'radio'
};

/** @component */
export { Radio };